import React from 'react';
import Icon from 'components/Utils/NewIcon';
import IconButton from '@material-ui/core/IconButton';
import './style.scss';

const PhysicianTopBar = (props) => (
  <div className="row top-row physician-top-bar">
    <div className="left-buttons">
      <IconButton onClick={props.onClose} className="close">
        <Icon className="white" src="xmark" />
      </IconButton>
    </div>
    <span className="large-title">Chat</span>
    <div className="right-buttons">
      <ArchiveButton archiveChat={props.archiveChat} />
    </div>
  </div>
);

const ArchiveButton = React.memo(
  ({ archiveChat }) =>
    archiveChat !== undefined && (
      <IconButton onClick={archiveChat} className="archive">
        <Icon
          width="20px"
          src="box-archive"
          className="white"
          showTooltip={true}
          tooltipPlace="left"
        />
      </IconButton>
    ),
);

export default PhysicianTopBar;
